import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { MetaContext } from "../context";
import { getDataById } from "./Utilities";
import { Flex, Line } from './Uikit';

export function StackInfo() {
  const context = useContext(MetaContext);
  return (
    <CSSstackInfo>
      {context["data"]["goal"].map((oneGoal, i) => {
        let nam = "";
        let q = 0;
        let tot = 0;
        if (
          context.handles.getStack().filter((itm) =>
            getDataById(context, itm['id'])["goal"].includes(oneGoal["id"])
          ).length
        ) {
          nam = oneGoal["title"];
          q = context.handles.getStack().filter((itm) =>
            getDataById(context, itm['id'])["goal"].includes(oneGoal["id"])
          ).length;
          tot = oneGoal["core"].length;
        }
        return (
          <CSSsm key={`info_${oneGoal['title']}`}>
            {Boolean(q) && (
              <Line>
                <Flex>
                  <span>{nam}</span>
                  {/* <span>{q} / {tot}</span>  */}
                  <Indicator q={q} total={tot} />
                </Flex>
              </Line>
            )}
          </CSSsm>
        );
      })}
    </CSSstackInfo>
  );
}

const CSSstackInfo = styled.div`
  /* border: 1px solid var(--main-border-color); */
  /* border-radius: 1em; */
  /* padding: 0.8em; */
  /* margin: 0.6em 0 0 0; */
`;

const CSSsm = styled.div`
  font-size: 0.8em;
  margin-bottom: 0.4em;
`;

export function Indicator({ q, total }) {
  const calcPersent = (q, total) => 100 / (total / q);

  return (
    <CSSback>
      <CSSi percent={calcPersent(q, total)} />
    </CSSback>
  );
}

const CSSi = styled.div`
  background: var(--main-accent-color);
  border-radius: 20px;
  height: 8px;
  width: ${({ percent }) => `${percent}%`};
  /* box-shadow: inset 0px -4px 5px -4px var(--main-accent-text-color) ; */
  /* margin-left: -0.5px; */
`;

const CSSback = styled.div`
  background: var(--main-bg-color);
  box-shadow: inset 0px 4px 5px -8px #000000;
  border-radius: 1em;
  width: 60px;
  height: 8px;
`;
